webpackJsonp([182723590155647],{

/***/ 929:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0004_careless_musketeer.jpg","type":"Unit","subtype":"Pirate","cost":2,"ATK":2,"HP":1,"rules_text_1":"⤵ → Deal 1 damage to a unit or building and 1 damage to your base.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Careless Musketeer","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"careless_musketeer"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"careless_musketeer","keywords":[],"imageRegex":"/careless_musketeer.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-careless-musketeer-f2b37db727a134215c88.js